import { CheckIcon } from "@heroicons/react/24/outline";
import { ForecastInput } from "./ForecastInput";

export const ChannelSplit = ({
    forecastType,
    access,
    shopifyValue,
    onChangeShopifyValue,
    amazonValue,
    onChangeAmazonValue,
    wholesaleValue,
    onChangeWholesaleValue,
    selectedMonth,
    selectedChannel,
    percentages,
    onReset,
    handleApplyAllMonths
}) => {
    return (
        <>
            <div className="space-y-4">
                <div className="flex items-center justify-between">
                    <span className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-base font-medium select-none">
                        Channel Split (%) - {selectedMonth}
                    </span>
                    <div className="flex items-center gap-2">
                        <div className={`flex items-center gap-1 ${percentages === 100 ? "text-green-600" : "text-red-600"}`}>
                            <CheckIcon className="h-4 w-4" />
                            <span className="text-sm font-medium">{percentages}%</span>
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-3 gap-4">
                    {((selectedChannel === "shopify_channel") || (selectedChannel === "all_channels")) && (
                        <ForecastInput
                            id="shopify-ad-spend"
                            label="Shopify %"
                            access={access}
                            inputValue={shopifyValue}
                            setInputValue={onChangeShopifyValue}
                            inputClassName={"!text-left"}
                        />
                    )}
                    {((selectedChannel === "amazon_channel") || (selectedChannel === "all_channels")) && (
                        <ForecastInput
                            id="amazon-ad-spend"
                            label="Amazon %"
                            access={access}
                            inputValue={amazonValue}
                            setInputValue={onChangeAmazonValue}
                            inputClassName={"!text-left"}
                        />
                    )}
                    {((selectedChannel === "wholesale_channel") || (selectedChannel === "all_channels")) && (
                        <ForecastInput
                            id="wholesale-ad-spend"
                            label="Wholesale %"
                            access={access}
                            inputValue={wholesaleValue}
                            setInputValue={onChangeWholesaleValue}
                            inputClassName={"!text-left"}
                        />
                    )}
                </div>
            </div>
            {access === "edit" && (
                <div className="flex gap-3">
                    {forecastType === "month" && (
                        <button
                            onClick={() => {
                                handleApplyAllMonths?.()
                            }}
                            className="ring-offset-background inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors border-input bg-background hover:bg-gray-100 border h-10 px-4 py-2"
                        >
                            Apply to All Months
                        </button>
                    )}
                    <button
                        className="ring-offset-background inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors border-input bg-background hover:bg-gray-100 border h-10 px-4 py-2"
                        onClick={() => {
                            onReset?.()
                        }}
                    >
                        Reset to Product Defaults
                    </button>
                </div>
            )}
        </>
    )
}